import React from 'react'
import agent from '../agent';
import { store, history } from '../store';
import { push } from 'react-router-redux';
import CryptoJs from 'crypto-js'
import { domainToASCII } from 'url';

export const onMoveBook = evt =>{
    // evt 가 문자열 (주소)
    if(typeof evt === 'string'){
        historyManager.push(evt);
    } 
}

export const changeStage = path => {
    //store.dispatch(push(path));
    historyManager.push(path); 
}

export const loading = () => {
    return <div>LOADING ...</div>
}

export const historyManager = {
    init: () => {
        window.historyList = [];
        window.onpopstate = () => {
            if(window.historyList.length){
                const fnc = window.historyList.pop();
                //console.log("######################## history cnt : " + window.historyList.length + ", pop path : " + window.location.pathname);

                if(typeof fnc === "function"){
                    fnc();
                    //console.log("########################")
                    //console.log(fnc)
                    //console.log("########################")
                }
            }
            window.Alert.close();

            // 뒤로가기시 추가 콜백
            if(typeof window.callBackward === 'function'){
                window.callBackward();
            }
        }
    },
    push: (callback, path) => {
        if(typeof callback === 'string'){
            window.historyList.push(null) 
            history.push(callback)
            //console.log("######################## 1.history cnt : " + window.historyList.length + ", push path : " + callback);
        }else{
            window.historyList.push(callback)
            if(!path) path = window.location.pathname
            history.push(path)
            //console.log("######################## 2.history cnt : " + window.historyList.length + ", push path : " + path);
        }
    },
    pop: () => {
        window.historyList.pop()
    }
}


export const getParameters = paramName => {
    // 리턴값을 위한 변수 선언
    var returnValue;

    // 현재 URL 가져오기
    var url = window.location.href;

    // get 파라미터 값을 가져올 수 있는 ? 를 기점으로 slice 한 후 split 으로 나눔
    var parameters = (url.slice(url.indexOf('?') + 1, url.length)).split('&');

    // 나누어진 값의 비교를 통해 paramName 으로 요청된 데이터의 값만 return
    for (var i = 0; i < parameters.length; i++) {
        var varName = parameters[i].split('=')[0];
        if (varName.toUpperCase() === paramName.toUpperCase()) {
            returnValue = parameters[i].split('=')[1];
            return decodeURIComponent(returnValue);
        }
    }
};

export const Crypt = () => {
    const key = "123456789";

    return {
        enc: value => CryptoJs.AES.encrypt(value, key).toString(),
        dec: value => CryptoJs.AES.decrypt(value, key).toString(CryptoJs.enc.Utf8)
    }
}

export const getConfig = key => {

    return window[key] + '/api';

}

// 앱 
export const native = () => {
    var cmd = {};

    this.isApp = agent.getSessionInfo().isApp; 
    
    cmd = {
        // 설치 앱 버전
        // cbVersion(param) > param = {data: {version: xx}}
        ver: () => {
            if(this.isApp) window.location.href = window.SCRAP_SCHEME + "://callVersion";
        },

        // 설치된 인증서 목록
        // cbCertList(param) > param = {data: {subjectName:'', serialNumber: '', notAfter:'', notBefore: ''}}
        certList: () => {
            if(this.isApp)  window.location.href = window.SCRAP_SCHEME + "://callcertList";
        },

        // 인증번호 받기(인증서 복사)
        // cbCopyCertNum(param) > param = {uid: ''}
        copyCertNum: () => {
            if(this.isApp)  window.location.href = window.SCRAP_SCHEME + "://callCopyCertNum";
        },

        // 인증서 가져오기
        // cbCopyCert(param) > param = {cert: {serialNumber: ''}}
        copyCert: (uid, isSave) => {
            if(this.isApp)  window.location.href = window.SCRAP_SCHEME + "://callCopyCert?uid=" + uid + "&isSave=" + isSave;
        },

        // 인증서 삭제
        // cbDeleteCert(param)
        deleteCert: idx => {
            if(this.isApp)  window.location.href = window.SCRAP_SCHEME + "://callDeleteCert?idx=" + idx;
        },
        
        // json 데이터 저장
        // cbSaveData(param)
        saveData: (key, json) => {
            if(this.isApp)  window.location.href = window.SCRAP_SCHEME + "://callSaveData?key=" + key + "&inJson=" + JSON.stringify(json);
        },

        // json 데이터 삭제
        // cbQueryRemove(param)
        deleteData: key => {
            if(this.isApp)  window.location.href = window.SCRAP_SCHEME + "://callQueryRemove?key=" + key;
        },

        // json 데이터 조회
        // cbQueryKeys(param) > param = {data: [{key:'CERT', data:[{serialNumber:'', pwd: ''}]},{key:'', data:[{key:jseq, serialNumber:''}]}]}
        loadData: () => {
            if(this.isApp)  window.location.href = window.SCRAP_SCHEME + "://callQueryKeys";
        },

        // 데이터 암호화
        // cbEnvParam(param) > param.envParam
        encData: param => {
            if(this.isApp)  window.location.href = window.SCRAP_SCHEME + "://callEnvParam?param=" + param;
        },

        // 인증서 비밀번호 확인
        // cbCertPwCheck(param)
        certPwCheck: (idx, pwd) => {
            if(this.isApp)  window.location.href = window.SCRAP_SCHEME + "://callCertPwCheck?idx=" + idx + "&pwd=" + encodeURIComponent(pwd);
        },

        // 권한체크
        hasPermission: (perms, cb) => {
            try{
                const permissions = window.cordova.plugins.permissions;
                let list = [];
                if(typeof perms === "string"){
                    list.push(permissions[perms])
                }else{
                    list = perms.map(d => permissions[d]);
                }

                permissions.hasPermission(list, status => {
                    if ( status.hasPermission ) {
                        if(typeof cb !== "undefined") cb(true);
                    }
                    else {
                        if(typeof cb !== "undefined") cb(false);
                    }
                });
            }catch(e){}
        },

        // 권한부여
        requestPermission: (perms, cb) => {
            try{
                const permissions = window.cordova.plugins.permissions;
                let list = [];
                if(typeof perms === "string"){
                    list.push(permissions[perms])
                }else{
                    list = perms.map(d => permissions[d]);
                }

                permissions.requestPermissions(list, status => {
                    if ( status.hasPermission ) {
                        if(typeof cb !== "undefined") cb(true);
                    }
                    else {
                        if(typeof cb !== "undefined") cb(false);
                    }
                });
            }catch(e){}
        }
        
    }

    return cmd;
}

/**
 * 앱 데이터 저장/조회/삭제
 * @param {JASAN or CERT} kind 
 * @param {cbQueryKeys를 통해 받은 [{key: "JASAN", data: [{}]}, {key: "CERT", data: [{}]} ]값} dataArr 
 * @param {true: dataArr 값이 즉 data, false: dataArr에서 해당 kind로 찾음} flag
 */
export const appData = (kind, dataArr, flag) => {
    
    var rtn = {};

    let data = [];
    if(flag){
        data = [...dataArr];
    }else{        
        for(let i=0; i<dataArr.length; i++){
            if(dataArr[i].key === kind){
                try{
                   data = JSON.parse(dataArr[i].data);
                }catch(e){
                    data = dataArr[i].data;
                }
                break;
            }
        }
    }

    if(kind === 'CERT'){
        // [{serialNumber: 'xxxx', pwd: 'xxx'},{serialNumber: 'xxxx', pwd: 'xxx'}]
        rtn = {
            get: serialNumber => {
                if(!serialNumber){ // 전체조회
                    return data ? data : [];
                }else{                    
                    if(data.length === 0) return null;

                    for(let i=0; i<data.length; i++){
                        if(data[i] && data[i].serialNumber == serialNumber) return data[i];
                    }

                    return null;
                }
            },

            set: item => {
                const serialNumber = item.serialNumber;
                let isExists = false;
                
                // 기존에 있으면 갱신
                for(let i=0; i<data.length; i++){
                    if(data[i] && data[i].serialNumber == serialNumber) {
                        data[i] = item;
                        isExists = true;
                        break;
                    }
                }

                // 없으면 등록
                if(!isExists) data.push(item);

                native().saveData(kind, data);
            },

            remove: serialNumber => {
                if(data.length !== 0) {
                    for(let i=0; i<data.length; i++){
                        if(data[i] && data[i].serialNumber == serialNumber) data.splice(i, 1);
                    }

                    native().saveData(kind, data);
                }
            }
        }
    }else if(kind === 'JASAN'){
        // [{key: jSeq, serialNumber: 'xxxx'},{key: jSeq, serialNumber: 'xxxx'}]
        rtn = {
            get: val => {
                if(!val){ // 전체조회
                    return data ? data : [];
                }else{
                    if(data.length === 0) return null;

                    for(let i=0; i<data.length; i++){
                        if(data[i] && data[i].key == val) return data[i];
                    }

                    return null;
                }
            },

            set: item => {
                let items = item;
                if(item instanceof Array == false){
                    items = [item];
                }

                for(let i=0; i<items.length; i++){
                    const key = items[i].key;
                    let isExists = false;
                    
                    // 기존에 있으면 갱신
                    for(let j=0; j<data.length; j++){
                        if(data[j] && data[j].key == key) {
                            data[j] = items[i];
                            isExists = true;
                            break;
                        }
                    }

                    // 없으면 등록
                    if(!isExists) data.push(items[i]);
                }

                native().saveData(kind, data);
            },

            remove: val => {
                if(data.length !== 0) {
                    for(let i=data.length-1; i>=0; i--){
                        if(data[i] && data[i].key == val) data.splice(i, 1);
                    }

                    native().saveData(kind, data);
                }else
                    return false;
            },

            removeCert: val => {
                if(data.length !== 0) {
                    for(let i=data.length-1; i>=0; i--){
                        if(data[i] && data[i].serialNumber == val) data.splice(i, 1);
                    }

                    native().saveData(kind, data);
                }else 
                    return false;
            }
        }
    }else{
        rtn = {
            get: () => {
                return data;
            }
        }
    }
   

    return rtn;
}

export const base64ToBlob = (base64Data, contentType="", sliceSize=512) => {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, {type: contentType});
    
    return blob;
}

/**
 * 이미지 불러오기(권한이 필요한 경우)
 */
export const loadUrlImage = (url, cb) => {
    const xhr = new XMLHttpRequest();
    xhr.responseType = 'arraybuffer';
    xhr.onload  = () => {
        if (xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
            const uInt8Array = new Uint8Array(xhr.response);
            let i = uInt8Array.length;
            let binaryString = new Array(i);
            while (i--)
            {
                binaryString[i] = String.fromCharCode(uInt8Array[i]);
            }
            var data = binaryString.join('');
            var base64 = window.btoa(data);

            if(cb) cb.call(null, "data:image/jpg;base64," + base64);
            //this.setState({ picture: "data:image/jpg;base64," + base64 })
        }
    };
    xhr.open('GET', getConfig("SUCCESS_API")+ url , true);
    xhr.setRequestHeader('access_token', agent.getSessionInfo().token); // window.sessionStorage.getItem('sct')
    xhr.send();
}

export const checkMobile = () => {
    if( /Android/i.test(navigator.userAgent)) {
        return 'android';
    }if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return 'ios';
    }else {
        return 'etc';
    }
}
/*
// 초기 수집 인트로 진행
export const getIntroStep = () => {
    const step = [
                    {link: '/asset/list', title: '자산 설정'},
                    {link: '/scrap', title: '자동 조회'}
                 ]
    
    const stepNo = window.sessionStorage.getItem("step");
    if(stepNo){        
        let pos = replaceNumber(stepNo);
        window.sessionStorage.setItem("step", pos+1);
    }
    return step[pos];    
}*/


// WEBPACK FOOTER //
// ./src/utils/common.js